// extracted by mini-css-extract-plugin
export default {"homeTiles":"HomeTilesStyles_homeTiles__GyP-y"};